<template>
  <div>
    <v-container>
      <v-btn @click="back" text class="text_btn">
        <v-icon>keyboard_arrow_left</v-icon>back
      </v-btn>
      <h1>User settings ({{ p_name }})</h1>
      <v-layout style="margin-top: 30px;margin-bottom:10px;">
        <v-flex xs6>
          <v-btn text class="text_btn" @click="d_new_user = true">
            <v-icon>person_add</v-icon>New user
          </v-btn>
          <v-btn text class="text_btn" @click="d_new_user_import = true">
            <v-icon>group_add</v-icon>Import
          </v-btn>
        </v-flex>
        <v-flex xs6>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-flex>
      </v-layout>
      <Loading v-if="!loaded" />
      <v-data-table
        v-if="loaded"
        :headers="headers"
        :items="items"
        :search="search"
        :options="{
      itemsPerPage: 25
    }"
        no-data-text="No users found"
        no-results-text="No users found for this search."
        class="elevation-1"
      >
        <template v-slot:item.type="{ item }">
          <span v-html="getTypeTemplate(item.type)"></span>
        </template>
        <template v-slot:item.active="{ item }">
          <span
            @click="toggleActiveStatus(item.id, !(item.active === '1' || item.active === 1 || item.active === true))"
            v-html="getActiveTemplate(item.active)"
          ></span>
        </template>
        <template v-slot:item.otp.active="{ item }">
          <span
            @click="() => { if (item.otp.active) { deactivate2FA(item.id); } }"
            v-html="get2FATemplate(item.otp.active)"
          ></span>
        </template>
        <template v-slot:item.reset_password="{ item }">
          <v-btn @click="startResetPassword(item.id)" text class="text_btn" small>
            <v-icon>vpn_key</v-icon>
          </v-btn>
        </template>
        <template v-slot:item.delete="{ item }">
          <v-btn @click="deleteUser(item.id)" text class="text_btn" small>
            <v-icon>delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>

      <!-- Dialog for adding users -->
      <v-dialog v-model="d_new_user" width="500">
        <v-card>
          <v-form @submit="createUser">
            <v-card-title class="headline" primary-title>New user</v-card-title>

            <v-card-text>
              <v-text-field ref="new_user_email" label="Email" />
              <v-text-field
                ref="new_user_password"
                :disabled="new_user_standard_password"
                type="password"
                label="Password"
              />
              <v-switch
                v-model="new_user_standard_password"
                ref="new_user_standard_password"
                :true-value="true"
                :false-value="false"
                :label="'Use standard password (User' + (new Date()).getFullYear() + ')'"
              ></v-switch>
              <v-select
                :items="languages"
                item-text="text"
                ref="new_user_language"
                label="Language"
                item-value="key"
              ></v-select>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text class="text_btn" type="submit">Create</v-btn>
              <v-btn
                color="default"
                text
                class="text_btn"
                type="button"
                @click="d_new_user = false; clearNewUserForm();"
              >Cancel</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>

      <v-dialog v-model="d_reset_password" width="500">
        <v-card>
          <v-form @submit="resetPassword">
            <v-card-title class="headline" primary-title>Reset Password</v-card-title>

            <v-card-text>
              <v-text-field
                ref="reset_user_password"
                :disabled="reset_user_standard_password"
                type="password"
                label="New Password"
              />
              <v-switch
                v-model="reset_user_standard_password"
                ref="reset_user_standard_password"
                :true-value="true"
                :false-value="false"
                :label="'Use standard password (User' + (new Date()).getFullYear() + ')'"
              ></v-switch>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text class="text_btn" type="submit">Reset</v-btn>
              <v-btn
                color="default"
                text
                class="text_btn"
                type="button"
                @click="d_reset_password = false; d_current_user = 0;"
              >Cancel</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>

      <!-- When deleting a user -->
      <v-dialog v-model="d_delete_user" width="500">
        <v-card>
          <v-card-title class="headline" primary-title>Delete user</v-card-title>

          <v-card-text>
            <p>Do you really want to delete this user. Please note that this can not be undone afterwards. The user will lose, all the access to his login information and his data immediately.</p>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red" text class="text_btn" type="button" @click="deleteUserConfirm">Delete</v-btn>
            <v-btn
              color="default"
              text
              class="text_btn"
              type="button"
              @click="d_delete_user = false; d_current_user = 0;"
            >Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Import a CSV to create new users. -->
      <v-dialog v-model="d_new_user_import" width="500">
        <v-card>
          <v-card-title class="headline" primary-title>Import new users</v-card-title>

          <v-card-text>
            <p>You can import here a CSV file with a list of email addresses, which should be inserted. If an email is already registered, it will skip it.</p>
            <v-file-input
              prepend-icon="attach_file"
              v-model="upload_csv_file"
              :show-size="true"
              label="Import CSV"
            ></v-file-input>
            <br />
            <v-text-field v-model="upload_csv_delimiter" label="Delimiter" placeholder="ex. ,"></v-text-field>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text class="text_btn" type="button" @click="startImport">Import</v-btn>
            <v-btn
              color="default"
              text
              class="text_btn"
              type="button"
              @click="d_new_user_import = false;"
            >Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Import process Step 2 -->
      <v-dialog v-model="d_new_user_import_step2" width="600">
        <v-card>
          <v-card-title class="headline" primary-title>Import new users</v-card-title>

          <v-card-text>
            <p>Grey marked entries will be skipped, because they are alreay registered. The password is at the beginning for all the same: User{{ (new Date()).getFullYear() }}</p>
            <v-data-table
              :headers="[{text: 'Email', value: 'email'}, {text: 'Language', value: 'language'}]"
              :items="upload_csv_table_data"
              sort-by="is_already_registered"
              :sort-desc="false"
            >
              <template v-slot:item.email="{ item }">
                <span
                  :style="'color:' + (item.is_already_registered ? 'grey' : 'black')"
                >{{ item.email }}</span>
                <dd
                  style="color:grey;font-size:11px;"
                  v-if="item.is_already_registered"
                >Will be skipped</dd>
                <dd style="color:black;font-size:11px;" v-else>New</dd>
              </template>
              <template v-slot:item.language="{ item }">
                <span
                  :style="'color:' + (item.is_already_registered ? 'grey' : 'black')"
                >{{ item.language }}</span>
              </template>
            </v-data-table>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              text
              class="text_btn"
              type="button"
              @click="startImportStep2"
            >Create</v-btn>
            <v-btn
              color="default"
              text
              class="text_btn"
              type="button"
              @click="d_new_user_import_step2 = false;"
            >Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Import process Step 3 -->
      <v-dialog v-model="d_new_user_import_step3" width="600">
        <v-card>
          <v-card-title class="headline" primary-title>Deactivate users</v-card-title>

          <v-card-text>
            <p>These users were not in your latest list. Do you want to deactivate them?</p>
            <v-data-table
              :headers="[{text: 'Email', value: 'email'}]"
              :items="items !== undefined ? items.filter(function(item) { return !item.notRemoveable; }) : []"
            ></v-data-table>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="error"
              text
              class="text_btn"
              type="button"
              @click="startImportStep3"
            >Deactivate</v-btn>
            <v-btn
              color="default"
              text
              class="text_btn"
              type="button"
              @click="window.location.reload()"
            >Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import { AuthSettings } from "../logic/AuthSettings";
import { Notifications } from "../notification";
import { Projects } from "../logic/Projects";

export default {
  name: "UserSettings",
  data() {
    return {
      headers: [
        {
          text: "ID",
          value: "id",
          width: "50px"
        },
        {
          text: "Email",
          value: "email",
          width: "auto"
        },
        {
          text: "Language",
          value: "lang",
          align: "center",
          width: "40px"
        },
        {
          text: "Type",
          value: "type",
          sortable: false,
          align: "center",
          width: "40px"
        },
        {
          text: "Active",
          value: "active",
          align: "center",
          width: "40px"
        },
        {
          text: "2FA",
          value: "otp.active",
          align: "center",
          width: "40px"
        },
        {
          text: "Reset Password",
          value: "reset_password",
          align: "center",
          sortable: false,
          width: "40px"
        },
        {
          text: "Delete",
          value: "delete",
          align: "left",
          sortable: false,
          width: "40px"
        }
      ],
      items: [],
      languages: [
        {
          key: "de",
          text: "German"
        },
        {
          key: "en",
          text: "English"
        },
        {
          key: "fr",
          text: "French"
        },
        {
          key: "it",
          text: "Italian"
        },
        {
          key: "es",
          text: "Spanish"
        }
      ],
      loaded: false,
      d_new_user: false,
      d_new_user_import: false,
      d_new_user_import_step2: false,
      d_new_user_import_step3: false,
      d_delete_user: false,
      d_reset_password: false,
      d_current_user: 0,

      new_user_standard_password: false,
      reset_user_standard_password: false,
      search: "",

      upload_csv_file: undefined,
      upload_csv_data: undefined,
      upload_csv_table_data: [],
      upload_csv_delimiter: ",",

      p_name: "...",
      project_id: 0
    };
  },
  mounted() {
    this.setTitle("User Settings");
    this.project_id = this.$route.params.project_id;
    this.loadProjectMeta(this.project_id);
    this.getAllUsers();
  },
  methods: {
    back() {
      this.$router.replace("/project/" + this.project_id);
    },
    getAllUsers() {
      AuthSettings.getAllUsers(this.project_id).then(
        function(response) {
          this.items = response.body;
          this.loaded = true;
        }.bind(this)
      );
    },
    async loadProjectMeta(project_id) {
      var project_response = await Projects.get(project_id);
      if (project_response.status === 200) {
        if (Array.isArray(project_response.body) && project_response.body.length > 0) {
          this.p_name = project_response.body[0].name;
        } else if (project_response.body && project_response.body.name) {
          this.p_name = project_response.body.name;
        }
      }
    },
    getActiveTemplate(status) {
      if (status === "1" || status === 1 || status === true) {
        return "<span style='color:green;' class='clickable_icon' title='Deactivate'><i class='fad fa-circle'></i></span>";
      } else {
        return "<span style='color:red;' class='clickable_icon' title='Activate'><i class='fad fa-circle'></i></span>";
      }
    },
    get2FATemplate(status) {
      if (status) {
        return "<span style='color:green;' class='clickable_icon' title='2-factor-authentication activated'><i class='fad fa-qrcode'></i></span>";
      } else {
        return "<span style='color:red;' title='2-factor-authentication not activated'><i class='fad fa-qrcode'></i></span>";
      }
    },
    async deactivate2FA(user_id) {
      if (confirm("Do you really want to deactivate the 2FA for this user?")) {
        var response = await AuthSettings.deactivateOTP(
          this.$route.params.project_id,
          user_id
        );
        if (response.status === 200) {
          Notifications.show(
            "The two factor authentication has been disabled for this user."
          );
          this.getAllUsers();
        } else {
          Notifications.show(response.message);
        }
      }
    },
    getTypeTemplate(types) {
      var template = "";
      types.forEach(function(item) {
        if (item === "emailpassword") {
          template +=
            "<i class='fad fa-envelope' style='cursor:default;' title='Email + password'></i>, ";
        } else {
          template +=
            "<span>" +
            item.charAt(0).toUpperCase() +
            item.slice(1) +
            "</span>, ";
        }
      });
      return template.slice(0, -2);
    },
    toggleActiveStatus(id, new_status) {
      AuthSettings.setActiveStatus(this.project_id, id, new_status).then(
        function(response) {
          if (response.status === 200) {
            this.getAllUsers();
          }
          Notifications.show(response.message);
        }.bind(this)
      );
    },
    createUser(event) {
      event.preventDefault();

      var email = this.$refs["new_user_email"].internalValue;
      var password = this.$refs["new_user_password"].internalValue;
      var standard_password = this.$refs["new_user_standard_password"]
        .internalValue;
      var language = this.$refs["new_user_language"].internalValue;

      if (standard_password) {
        password = "User" + new Date().getFullYear();
      }

      AuthSettings.createUser(
        this.project_id,
        email.trim(),
        password,
        language.trim()
      ).then(
        function(response) {
          if (response.status === 200) {
            this.getAllUsers();
            this.clearNewUserForm();
          }
          Notifications.show(response.message);
        }.bind(this)
      );
    },
    deleteUserConfirm() {
      AuthSettings.deleteUser(this.project_id, this.d_current_user).then(
        function(response) {
          if (response.status === 200) {
            this.getAllUsers();
          }
          this.d_delete_user = false;
          this.d_current_user = 0;
          Notifications.show(response.message);
        }.bind(this)
      );
    },
    deleteUser(user_id) {
      this.d_delete_user = true;
      this.d_current_user = user_id;
    },
    startResetPassword(user_id) {
      this.d_reset_password = true;
      this.d_current_user = user_id;
    },
    resetPassword(event) {
      event.preventDefault();

      var password = this.$refs["reset_user_password"].internalValue;
      var standard_password = this.$refs["reset_user_standard_password"].internalValue;

      if (standard_password) {
        password = "User" + new Date().getFullYear();
      }

      AuthSettings.updatePassword(this.project_id, this.d_current_user, password).then(
        function(response) {
          if (response.status === 200) {
            this.d_reset_password = false;
            this.d_current_user = 0;
            this.$refs["reset_user_password"].internalValue = "";
            this.reset_user_standard_password = false;
          }
          Notifications.show(response.message);
        }.bind(this)
      );
    },
    clearNewUserForm() {
      this.$refs["new_user_email"].internalValue = "";
      this.$refs["new_user_password"].internalValue = "";
      this.$refs["new_user_standardpassword"].internalValue = false;
      this.$refs["new_user_language"].internalValue = "";
    },

    startImport() {
      var reader = new FileReader();
      reader.readAsText(this.upload_csv_file);
      reader.onload = function() {
        this.upload_csv_data = reader.result;
        this.processImport();
      }.bind(this);
    },
    processImport() {
      var rows = this.upload_csv_data.split("\n");
      rows.forEach(
        function(row) {
          var is_already_registered = false;
          var row_parts = row.split(this.upload_csv_delimiter);
          var email = row_parts[0].trim();

          this.items.forEach(
            function(item_row, index) {
              if (item_row.email === email) {
                is_already_registered = true;
                this.items[index].notRemoveable = true;
              }
            }.bind(this)
          );

          this.upload_csv_table_data.push({
            email: email,
            language: row_parts[1].trim(),
            is_already_registered: is_already_registered
          });
        }.bind(this)
      );
      this.d_new_user_import = false;
      this.d_new_user_import_step2 = true;
    },
    startImportStep2() {
      //Import finally the users
      this.upload_csv_table_data.forEach(
        async function(row) {
          if (!row.is_already_registered) {
            await AuthSettings.createUser(
              this.project_id,
              row.email,
              "User" + new Date().getFullYear(),
              row.language
            );
          }
        }.bind(this)
      );

      this.d_new_user_import_step2 = false;
      this.d_new_user_import_step3 = true;
    },
    startImportStep3() {
      //Deactivate not used users.
      var deactivatable_accounts =
        this.items !== undefined
          ? this.items.filter(function(item) {
              return !item.notRemoveable;
            })
          : [];

      deactivatable_accounts.forEach(
        async function(account) {
          await this.toggleActiveStatus(account.id, false);
        }.bind(this)
      );

      this.d_new_user_import_step3 = false;

      setTimeout(function() {
        window.location.reload();
      }, 2000);
    }
  }
};
</script>

<style>
.clickable_icon > i {
  cursor: pointer;
  transition: 0.3s;
}
.clickable_icon:hover > i {
  transform: scale(2) !important;
  color: grey;
  transition: 0.3s;
}
</style>